module.exports = __webpack_public_path__ + "img/MYFRAC.902f2270.gif";